const request = require("request");
const BASE_URL = 'https://api.otpless.com/api/v1/user';

const getSignupUrl = () => {
    let options = {
        method: "GET",
        url: BASE_URL + '/getSignupUrl',
        headers: {
            "Content-Type": "application/json",
            "clientid": process.env.OTPLESS_CLIENTID,
            "clientsecret": process.env.OTPLESS_CLIENTSECRET,
            Accept: "*/*",
        },
        json: true
    }
    return new Promise((resolve, reject) => {
        request(options, function (error, response) {
            if (error) reject(error);
            resolve(response);
        });
    });
};

const getUserDetails = (token) => {
    let options = {
        method: "POST",
        url: BASE_URL + '/getUserDetails',
        headers: {
            "Content-Type": "application/json",
            "clientid": process.env.OTPLESS_CLIENTID,
            "clientsecret": process.env.OTPLESS_CLIENTSECRET,
            Accept: "*/*",
        },
        body: {
            "token": token
        },
        json: true
    }
    return new Promise((resolve, reject) => {
        request(options, function (error, response) {
            if (error) reject(error);
            resolve(response);
        });
    });
};

module.exports = {
    getSignupUrl,
    getUserDetails
}